  <template >
   <div class="formPosition" v-role="'ped'">
     <template>
  <v-container class="grey lighten-5">
    <v-row no-gutters>
      <v-col >
          <h4 style="text-align:center;"> <span> Pesquisa e Actualize os dados em Transitação</span></h4>

<div class="text-center">

 <v-container fluid>
    <v-row align="center">

      <v-col class="d-flex" cols="3" sm="5">

      </v-col>
      <v-col class="d-flex" cols="3" sm="5">
        <div v-if="$store.state.hasMessage" :class="$store.state.classMessage">{{ $store.state.textMessage }}</div>
      </v-col>

    <v-btn class="mx-2" fab dark color="indigo" @click="dialog = true">
              <v-icon dark>add</v-icon>
            </v-btn>

    </v-row>

  </v-container>
    </div>
      </v-col>
    </v-row>

     <v-card
    class="mx-auto"
  >
    <v-list-item>
      <v-list-item-avatar color="grey"></v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title class="headline">Painel de Transação de Dados</v-list-item-title>
        <v-list-item-subtitle>Envie transações de dados</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>

<v-row>

  <v-col md="12">
    <v-card-text>
      <strong> {{titulo}}</strong>
    </v-card-text>
    <hr>

  </v-col>

</v-row>
<v-row>
  <v-col md="8">
       <v-textarea
          outlined
           label="Escreva a transação aqui"
           v-model="transacao"
         ></v-textarea>
  </v-col>
 <v-col md="4" >
   <v-list rounded>
      <v-subheader>Parametros</v-subheader>
      <v-list-item-group   color="primary">
        <v-list-item
          v-for="(item, i) in parametros"
          :key="i"
        >
          <v-list-item-icon>
            <v-icon @click="removerItemLista(i)" >delete</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title >{{item}}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-list>

 </v-col>
</v-row>
<v-row>
   <v-col md="5"></v-col>
   <v-col md="3">
     <v-btn @click="continuarTransacao()" color="primary" >Efectuar a transação</v-btn>
   </v-col>
</v-row>
  </v-card>

  </v-container>
<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="600px">

      <v-card>
        <v-card-title>
          <span class="headline">Informe os dados</span>
     <span  v-if="$store.state.hasMessage" :class="$store.state.classMessage" >{{$store.state.textMessage}}</span>

        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
               <v-col cols="12" sm="6" md="8">
                <v-text-field label="Insira o valor dos parametros" required
                    v-model="parametro"
                >

                </v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="2">
                 <v-btn @click="AddParametro" class="mx-2" fab dark color="indigo">
                <v-icon dark>add</v-icon>
              </v-btn>
              </v-col>

            </v-row>
          </v-container>
         </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialog = false">Terminar</v-btn>
         </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>

  <v-row justify="center">
    <v-dialog v-model="dialog_confirmacao" persistent max-width="490">
      <v-card>
        <div v-if="$store.state.hasMessage" :class="$store.state.classMessage">{{ $store.state.textMessage }}</div>
        <v-card-title class="headline">Desejas continuar com essa operação?</v-card-title>
        <v-card-text>Essa operação irá afectar o sistema como um todo, por isso pergunto novamente tens realmente a certeza de que desejas continuar com essa operação?</v-card-text>
        <v-card-actions>
          <v-row>
              <v-col md="10"></v-col>
                <v-col md="2" v-if="progresso">
                    <v-progress-circular
                  :size="50"
                  color="green"
                  indeterminate
                ></v-progress-circular>
                </v-col>

                </v-row>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="dialog_confirmacao=false">Cancelar</v-btn>
          <v-btn color="green darken-1" text @click="save()">Continuar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
</template>
   </div>
</template>

<script>
import axios from '../../plugins/axios'
export default {
  data: () => ({

    select1: null,
    pesquisa_parameto: null,
    estudante_dados: [],
    parametros: [],
    dialog_update: false,
    idMatricula: null,
    msg_pesquisa: true,
    transacao: '',
    parametro: '',
    pesquisa: '',
    estudante: true,
    dialog: false,
    progresso_2: false,
    dialog_confirmacao: false,
    progresso_3: false,
    progresso: true,
    pessoa: [],
    titulo: 'Historico Acadedémico',
    progress: false,
    Pessoas_filtro: [],
    ruleRequired: [value => value || 'campo obrigatorio'],
    nome: '',
    matricula: '',
    anolectivo: '',
    Resultados:
    [
      { descricao: 'Não Transita' },
      { descricao: 'Transita' }
    ],
    headers: [
      { text: 'Nome do Estudante', value: 'nome' },
      { text: 'Bilhete / Documento', value: 'bi' },
      { text: 'Ano Lectivo', value: 'anoLectivo' },
      { text: 'Resultado', value: 'resultado' },
      { text: 'ControloUltimoAnoParaProximo', value: 'ControloUltimoParaOproximoAno' },
      { text: 'Instituicao', value: 'descricao' },
      { text: 'Actions', value: 'action', sortable: false }
    ],

    headersf: [
      { text: 'Ano de Admissão ', value: 'descricao_curso' },
      { text: 'Função', value: 'idAno_Academico' }
    ],

    editedItem: {
      ControloUltimoParaOproximoAno: '',
      ResidenteEm: '',
      anoLectivo: '',
      anoacademico: '',
      anolectivo: '',
      auto_data: '',
      autor: null,
      bi: '',
      certificado: null,
      data_: '',
      data_2: '',
      dataemissaobi: '',
      datanascimento: '',
      descricao: '',
      email: '',
      emitirCertificado: '',
      emitirCertificadoAutor: null,
      emitirCertificadoData: null,
      emitirCertificadoValidacaoStep: '',
      enable: '',
      fkPessoa: '',
      flag_dados_preparados: null,
      foto: null,
      idCurso: 0,
      idInstituicao: 0,
      idMAtricula: '',
      idMatricula: '',
      idMunicipio: 0,
      idPEssoa: '',
      idPerfil: '',
      instituicao: '',
      instituicaodescricao: '',
      morada: '',
      nome: '',
      nomedamae: '',
      nomedopai: '',
      pessoa: '',
      pkPessoa: '',
      resultado: '',
      sexo: '',
      sigla: '',
      status_2: '',
      telefone: '',
      trasferidoIN: ''
    },
    editedIndex: -1

  }),

  computed: {

    idclasse () {
      return this.$store.state.idclasse
    }
  },
  created () {
    // check if classe has been selected otherwise send back to painel to select

  },
  methods: {

    async  Pesquisar () {
      try {
        this.progresso = true
        this.estudante_dados = await axios
          .get('/PesquisaTransitacao/' + this.pesquisa)
          .then(res => res.data)
        this.progresso = false

        if (!this.estudante_dados.length) { this.msg_pesquisa = false } else { this.msg_pesquisa = true }
      } catch (error) {
      }
    },

    continuarTransacao () {
      this.dialog_confirmacao = true
    },

    async Salvar_Transitacao () {
      this.progresso_2 = true

      this.ObterPessoa()
      setTimeout(() => {
        if (this.pessoa.length) {
          let params =
             {
               matricula: this.matricula.trim(),
               nome: this.nome,
               anolectivo: this.anolectivo.trim(),
               fkPessoa: this.pessoa[0].pkPessoa,
               controloAno: null,
               flagActualizar: 0,
               resultado: null
             }

          this.InserteOrUpdateTransitacao(params)
          this.progresso_2 = false
        } else {
          this.text = 'Este estudante não foi cadastrado'
          this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 8000 })

          this.progresso_2 = false
        }
      }, 1000)
    },

    async  show_dialogo_transitacao () {
      this.dialog = true
    },

    removerItemLista (index) {
      this.parametros.splice(index, 1)
    },

    async  ObterPessoa () {
      try {
        this.pessoa = await axios
          .get('/ObterPessoa/' + this.matricula)
          .then(res => res.data)
      } catch (error) {
        this.progresso = false
      }
    },

    AddParametro () {
      this.parametros.unshift(this.parametro)
    },

    async  save () {
      let params =
      {
        transacao: this.transacao,
        parametros: this.parametros
      }

      try {
        // eslint-disable-next-line no-unused-vars
        let msg = await axios
          .post('/transacao-data', params)
          .then(res => res.data)

        /* if (msg.length) {
          corMensagem = 'msgError'
          this.text = 'Ocorreu um erro ao tentar inserir o estudante'
        } else {
          corMensagem = 'msgSucess'
          this.text = 'Operação efectuada com sucesso'
          this.dialog = false
        }
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': corMensagem, 'timeout': 8000 })
        this.progresso_2 = false */
      } catch (error) {
        this.progresso_2 = false
      }

      // this.$store.dispatch('textMessage', { 'msg': 'Ocorreu um erro ao tentar executar a operação', 'classMessage': 'msgError', 'timeout': 4000 })
    },

    async  InserteOrUpdateTransitacao (params) {
      try {
        let corMensagem = 'msgError'
        let msg = await axios
          .post('/TransitacaoInsertOrUpdate', params)
          .then(res => res.data)
        if (msg.length) {
          corMensagem = 'msgError'
          this.text = 'Ocorreu um erro ao tentar inserir o estudante'
        } else {
          corMensagem = 'msgSucess'
          this.text = 'Registro inserido com sucesso'
          this.dialog = false
          this.Limpar()
        }
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': corMensagem, 'timeout': 8000 })
        this.progresso_2 = false
      } catch (error) {
        this.progresso_2 = false
      }
    },

    async Salvar_Actualizacao () {
      this.progresso_3 = true

      let params = {
        anolectivo: this.editedItem.anoLectivo,
        matricula: this.editedItem.idMAtricula,
        nome: this.editedItem.nome,
        fkPessoa: this.editedItem.pkPessoa,
        controloAno: this.editedItem.ControloUltimoParaOproximoAno,
        flagActualizar: 1,
        resultado: this.editedItem.resultado
      }

      try {
        let corMensagem = 'msgError'
        let msg = await axios
          .post('/TransitacaoInsertOrUpdate', params)
          .then(res => res.data)
        if (msg.length) {
          corMensagem = 'msgError'
          this.text = 'Ocorreu um erro ao tentar inserir o estudante'
        } else {
          corMensagem = 'msgSucess'
          this.text = 'Registro Actualizado com sucesso'
          this.estudante_dados = []
          this.dialog_update = false
          this.Limpar()
        }
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': corMensagem, 'timeout': 8000 })
        this.progresso_3 = false
      } catch (error) {
        this.progresso_3 = false
      }
      this.progresso_3 = false
    },

    callUpdateDialog (item) {
      this.editedItem = Object.assign({}, item)
      this.dialog_update = true
    },

    Limpar () {
      // eslint-disable-next-line no-unused-expressions
      this.nome = ''
      this.anolectivo = ''
      this.matricula = ''
    }
  }

}

</script>
